import type { ApiAsyncTaskItem } from '@api/asyncTasks';

export const EVENT_ORDER_ITEM_OPERATION = 'events/generate_consolidated_event_order';
const CAPACITY_ITEM_OPERATION = 'update_capacities';

export function isEventOrderItem(item: ApiAsyncTaskItem): boolean {
  return item.operation === EVENT_ORDER_ITEM_OPERATION;
}

export function subjectEditUrl(item: ApiAsyncTaskItem): string | null {
  if (item.subject_type === 'Product' && item.subject_id != null) {
    return `/products/${item.subject_id}/edit`;
  }
  // Only capacity items may use the date-based route.
  if (item.operation === CAPACITY_ITEM_OPERATION && item.subject_type == null) {
    const date = paramDate(item.params);
    if (date) return `/capacities?serving_date=${date}`;
  }
  return null;
}

function paramDate(params: Record<string, unknown> | undefined): string | null {
  const raw = params?.date;
  return typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(raw) ? raw : null;
}
